import { IFilters } from '../../types/filters';
import { EDealType, EGeoName, ECategory } from '../../types/share';
import { TReduxActions } from '../../types/redux';
import { filtersActionTypes } from '../../constants/actionTypes';

const defaultState = {
  dealType: EDealType.Sale,
  region: EGeoName.Msk,
  category: ECategory.FlatSale,
};

function getDefaultCategory(dealType: EDealType) {
  return dealType === EDealType.Sale ? ECategory.FlatSale : ECategory.FlatRent;
}

export function filtersReducer(state: IFilters = defaultState, action: TReduxActions) {
  switch (action.type) {
    case filtersActionTypes.SET_DEAL_TYPE:
      return {
        ...state,
        dealType: action.payload,
        /**
         * Сбрасываем category, так как enum'ки для аренды и продажи разные
         */
        category: getDefaultCategory(action.payload),
      };

    case filtersActionTypes.SET_REGION:
      return {
        ...state,
        region: action.payload,
      };

    case filtersActionTypes.SET_CATEGORY:
      return {
        ...state,
        category: action.payload,
      };

    default:
      return state;
  }
}
